import { Validators } from '@angular/forms';
import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
import { PolluxFormDisabledEvaluator } from '../../../../../components/common/pollux-form-disabled-evaluator/pollux-form-disabled-evaluator';
import { PolluxValidators } from '../../../../../components/common/pollux-validators/pollux-validators';
import { ValuationEventsValidators } from './valuation-events-validators';

export const valuationEventsFormConfig: PolluxFormConfig[] = [
  {
    name: 'Oid',
    value: 'Oid',
    disabled: true
  },
  {
    name: 'ProjectID',
    value: 'ProjectID',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ProjectName',
    value: 'ProjectName',
    disabled: true
  },
  {
    name: 'ProjectIDDescription',
    value: 'ProjectIDDescription',
    disabled: true
  },
  {
    name: 'ValuationPortfolioName',
    value: 'ValuationPortfolioName',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(255), Validators.minLength(1)]
  },
  {
    name: 'ValuationDate',
    value: 'ValuationDate',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationStatusId',
    value: 'ValuationStatusId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'VolumeOfValuation',
    value: 'VolumeOfValuation',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'LiabilityTypeId',
    value: 'LiabilityTypeId',
    disabled: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'niy',
    value: 'niy',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ney',
    value: 'ney',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'nry',
    value: 'nry',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ClientManual',
    value: 'ClientManual',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'Reference',
    value: 'Reference',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(255)]
  },
  {
    name: 'SignedBy',
    value: 'SignedBy',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(255)]
  },
  {
    name: 'SignedAndReceivedOn',
    value: 'SignedAndReceivedOn',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'deadlineDraft',
    value: 'deadlineDraft',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'deadlineFinal',
    value: 'deadlineFinal',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'InstructionDate',
    value: 'InstructionDate',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ReportDate',
    value: 'ReportDate',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'LeadingMethodId',
    value: 'LeadingMethodId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(1)]
  },
  {
    name: 'DerivationsFromInstructionLetterId',
    value: 'DerivationsFromInstructionLetterId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'Derivations',
    value: 'Derivations',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(255)]
  },
  {
    name: 'BusinessLineNrId',
    value: 'BusinessLineNrId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'Remark',
    value: 'Remark',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(255)]
  },
  {
    name: 'TemplateId',
    value: 'TemplateId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0)],/*0 is Default template*/
    formReferencingValidators: [ValuationEventsValidators.template()]
  },
  {
    name: 'LanguageId',
    value: 'LanguageId',
    validators: [Validators.min(1)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'NumberOfPropertiesManually',
    value: 'NumberOfPropertiesManually',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0), PolluxValidators.integer(true)]
  },
  {
    name: 'NumberOfPropertyCalc',
    value: 'NumberOfPropertyCalc',
    disabled: true
  },
  {
    name: 'Client',
    value: 'Client',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  },
  {
    name: 'PeriodOfValuationID',
    value: 'PeriodOfValuationID',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'RecordStatusId',
    value: 'RecordStatusId',
    keepEnabled: true
  },
  {
    name: 'LastSyncStatus',
    value: 'LastSyncStatus',
    disabled: true
  },
  {
    name: 'LastSync',
    value: 'LastSync',
    isDate: true,
    disabled: true
  },
  {
    name: 'SyncBy',
    value: 'SyncBy',
    disabled: true
  },
  {
    name: 'ArgusPortfolioId',
    value: 'ArgusPortfolioId',
    disabled: false,
    validators: [PolluxValidators.integer(true)]
  },
  {
    name: 'PropertiesSynced',
    value: 'PropertiesSynced',
    disabled: true
  },
  {
    name: 'OwnerUserID',
    value: 'OwnerUserID',
    disabled: true
  },
  {
    name: 'DateCreated',
    value: 'DateCreated',
    isDate: true,
    disabled: true
  },
  {
    name: 'OwnerBuID',
    value: 'OwnerBuID',
    disabled: true
  },
  {
    name: 'ModifiedByUserID',
    value: 'ModifiedByUserID',
    disabled: true
  },
  {
    name: 'HistoryLastEntry',
    value: 'HistoryLastEntry',
    isDate: true,
    disabled: true
  },
  {
    name: 'ModifiedBuID',
    value: 'ModifiedBuID',
    disabled: true
  },
  {
    name: 'filledOnSave',
    fixedValue: 'Filled on save',
    disabled: true
  },
  {
    name: 'DisplayValuesOverTimeId',
    value: 'DisplayValuesOverTimeId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(1)]
  },
  {
    name: 'JllJobId',
    value: 'JllJobId'
  }
];
